<template>
  <nav aria-label="You are here:" role="navigation">
    <TransitionGroup
      tag="ul" 
      :css="false"
      @before-enter="beforeEnter"
      @enter="enter"
      class="bcrumbs">
      <li v-for="crumb in items" :key="crumb.ID">
          <a v-if="crumb.route == null" 
            :style="{ color: color }"
            :href="crumb?.href">
              {{ crumb.text }}
          </a>
          <router-link :style="{ color: color }"
            :to="`${crumb.route.to}`"
            v-if="crumb.route != null">
              {{ crumb.text }}
          </router-link>
      </li>
    </TransitionGroup>
  </nav>
</template>

<script>
import { ref, watch } from "vue";
export default {
  props: ["breadcrumb", "showBread", "color"],
  setup(props) {

    const beforeEnter = (el) => {
      el.style.opacity = 0;
    }

    const animationInterval = 200;

    const items = ref([])

    watch(()=>props.breadcrumb, (newval,oldval) => {
      items.value = props.breadcrumb.map((el,index) => {
        return {
          ...el,
          ID: `${index}${Date.now()}${el.text}`
        }
      })
    })

    const enter = (el, done) => {
      const delay = Array.from(el.parentNode.children).indexOf(el) * animationInterval; 
      el.style.opacity = 0;
      el.style.transitionProperty = 'opacity, transform';
      el.style.transitionDuration = '0.8s, 1s';
      el.style.transitionTimingFunction = 'ease-in, ease-in';
      el.style.transitionDelay = `${delay}ms, ${delay}ms`;
      setTimeout(() => {
        el.style.opacity = 1;
        done();
      }, animationInterval);
    }

    return {
      beforeEnter,
      enter,
      items
    }
  }
}
</script>

<style scoped>
nav {
  display: block;
}

.bcrumbs {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  white-space: nowrap;
  list-style: none;
}

.bcrumbs li:not(:last-child):after {
  position: relative;
  top: 1px;
  margin: 0 .75rem;
  opacity: 1;
  content: "/";
  color: #cacaca;
}

.bcrumbs li {
  font-size: 15px;
  font-family: Montserrat;
  text-transform: none;
}


[v-cloak] {
  display: none;
}

.bcrumbs a {
  color: #a7a5a5;
}

.bcrumbs a:hover {
  color: #c9c7c7;
  text-decoration: none;
}

@media (min-width : 768px) and (max-width : 1024px) {
  .bcrumbs li {
    font-size: 14px;
  }
}

@media (max-width : 767px) {
  nav {
    display: none;
  }
}
</style>